import { Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import Public from './components/Public'
import Login from './features/auth/Login'
import DashLayout from './components/DashLayout'
import Welcome from './features/auth/Welcome'
import NotFound from './components/NotFound'
import ContactUs from './components/ContactUs'
import ShowHep from './features/portal/showHep'

import HepList from './features/hep/HepList'
import UsersList from './features/users/UsersList'
import ExercisesList from './features/exercises/exercisesList'
import ExercisesListForUsers from './features/exercises/exercisesListForUsers'
import HepExerciseList from './features/hep/HepExerciseList'
import BodypartsList from './features/exercises/BodypartsList'
import ExercisetypesList from './features/exercises/ExercisetypesList'

import EditUser from './features/users/EditUser'
import NewUserForm from './features/users/NewUserForm'
import Profile from './features/users/Profile'

import EditHep from './features/hep/EditHep'
import NewHep from './features/hep/NewHep'
import PrintHep from './features/hep/PrintHep'

import EditExercise from './features/exercises/EditExercise'
import NewExercise from './features/exercises/NewExercise'

import EditHepExercise from './features/hep/EditHepExercise'
import NewHepExercise from './features/hep/NewHepExercise'

import TodoList from './features/todo/TodoList'
import EditToDo from './features/todo/editToDo'

import UserEmail from './features/emails/UserEmail'
import FileUploader from './features/emails/FileUploader'

import Prefetch from './features/auth/Prefetch'
import PersistLogin from './features/auth/PersistLogin'
import RequireAuth from './features/auth/RequireAuth'
import { ROLES } from './config/roles'
import useTitle from './hooks/useTitle'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

function App() {
	useTitle('DPE by Reset-Wellness')

	return (
		<>
			<Routes>
				<Route path="/" element={<Layout />}>
					{/* public routes */}
					<Route index element={<Public />} />
					<Route path="login" element={<Login />} />
					<Route path="contactus" element={<ContactUs />} />
					<Route path="portal/:hepid" element={<ShowHep />} />					


					{/* Protected Routes */}
					<Route element={<PersistLogin />}>
						<Route element={<RequireAuth allowedRoles={[...Object.values(ROLES)]} />}>
							<Route element={<Prefetch />}>
								<Route path="dash" element={<DashLayout />}>

									<Route index element={<Welcome />} />
									<Route path="help" element={<ContactUs />} />

									<Route element={<RequireAuth allowedRoles={[ROLES.Manager, ROLES.Admin]} />}>
										<Route path="users">
											<Route index element={<UsersList />} />
											<Route path=":id" element={<EditUser />} />
											<Route path="new" element={<NewUserForm />} />
										</Route>
									</Route>

									<Route path="hep">
										<Route index element={<HepList />} />
										<Route path=":id" element={<EditHep />} />
										<Route path="new" element={<NewHep />} />
										<Route path="print/:id" element={<PrintHep />} />
									</Route>

									<Route path="hep/exercises">
										<Route index element={<HepExerciseList />} />
										<Route path=":id" element={<EditHepExercise />} />
										<Route path="new/:id" element={<NewHepExercise />} />
									</Route>

									<Route path="todos">
										<Route index element={<TodoList />} />
										<Route path=":id" element={<EditToDo />} />
									</Route>

									<Route path="upload" element={<FileUploader />} />

									<Route path="profile/:id" element={<Profile />} />

									<Route path="exerciselist" element={<ExercisesListForUsers />} />

									<Route element={<RequireAuth allowedRoles={[ROLES.Admin]} />}>
										<Route path="exercises">
											<Route index element={<ExercisesList />} />
											<Route path=":id" element={<EditExercise />} />
											<Route path="new" element={<NewExercise />} />
										</Route>
									</Route>

									<Route element={<RequireAuth allowedRoles={[ROLES.Admin]} />}>
										<Route path="exercises/bodyparts">
											<Route index element={<BodypartsList />} />
										</Route>
									</Route>

									<Route element={<RequireAuth allowedRoles={[ROLES.Admin]} />}>
										<Route path="exercises/types">
											<Route index element={<ExercisetypesList />} />
										</Route>
									</Route>

									<Route element={<RequireAuth allowedRoles={[ROLES.Admin]} />}>
										<Route path="emails">
											<Route path="users/:id" element={<UserEmail />} />
										</Route>
									</Route>

								</Route>{/* End Dash */}
							</Route>
						</Route>
					</Route>{/* End Protected Routes */}

				</Route>

				
				<Route path="*" element={<NotFound />} />

			</Routes>
			<ToastContainer />
		</>



	);
}

export default App;
